"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllMethodNames = void 0;
const isFunction_1 = require("./isFunction");
const getAllMethodNames = (obj) => Object.getOwnPropertyNames(obj).filter(isFunction_1.isFunction);
exports.getAllMethodNames = getAllMethodNames;
